<template>
	<!-- style="margin-top: 0.4rem;" -->
	<div class="pageCont">
		<!-- <Header></Header> -->
		<!-- 头部导航 -->
		<div class="indexbox">
			<div class="heardbox">
				<div class="heard_fl">
					<van-tabs v-model="Tabactive" color="var(--tabtxt-color)" background="var(--bg-color)"
						title-active-color="var(--tabact-color)" title-inactive-color="var(--tabinact-color)"
						@click="onTabClick">
						<!-- 一级导航 -->
						<van-tab v-for="(item, index) in TabList" :key="index" :title="item.title">
							<div></div>
						</van-tab>
						<!-- 一级导航end -->
					</van-tabs>
				</div>
				<div class="heard_fr">
					<router-link :to="{name: 'search'}" class="flexC">
						<van-icon name="search" color="var(--themetext-color)" size="20px" />
					</router-link>
					<div @click="navigate('message')" class="flexC">
						<van-icon name="chat-o" color="var(--themetext-color)" size="20px" />
					</div>
					<!-- 语言 -->
					<div class="hdcn flexC">
						<!-- <van-popover v-model="showPopover" trigger="click" :actions="actions" :close-on-click-outside="false" @select="onSelect"> -->
						<van-popover v-model="showPopover" placement="bottom-end" trigger="click" :overlay="true">
							<div v-for="(item, index) in actions" :key="index" class="tipslang"
								@click="onSelect(item,index)">
								<img :src="item.img" />
								<span>{{ item.label }}</span>
							</div>
							<template #reference>
								<a href="javascript:;" class="hdcna flexC MenuCN" @click="showLang"
									:class="{ 'on': flag }">
									<!-- <span class="wapiconfont icon-duoyuyan"></span> -->
									<img class="langimg" :src="Curlang.img" />
									<!-- <p>语言</p> -->
									<!-- <p>{{$t('message.language')}}</p> -->
									<!-- <p>{{Curlang.lang}}</p> -->
									<p class="langtxt">{{Curlang.value}}</p>
									<span class="wapiconfont icon-xiangyoujiantou"></span>
								</a>
							</template>
						</van-popover>
					</div>
					<!-- 语言end -->
				</div>
			</div>
			<!-- 二级导航 -->
			<div v-if="categoryList.length>0" class="heardtwobox">
				<!-- <div class="catelist">
					<div class="cateitem">
					</div>
				</div> -->
				<section class="IndTit flex fl-bet Huans">
					<div class="swiper" id="thumbs2">
						<div class="swiper-wrapper">
							<van-tabs background="var(--bg-color)" title-active-color="#fff"
								title-inactive-color="#6c6c6c" color="blue" v-model="active" swipeable sticky
								offset-top="45px" @change="cateChange">
								<van-tab v-for="(item, index) in categoryList" :key="index">
									<div :class="{'swiper-slide-thumb-active' : cateid==item.id}" slot="title">
										<div class="Huans IndTita flexC fl-cen">
											<!-- 	<span class="wapiconfont icon-a-tiyu1" v-if="item.gamesType == 'SPORTS'"></span> -->
											<p>{{item.title}}</p>
										</div>
									</div>
									<!-- 内容开始 -->
									<!-- 内容end -->
								</van-tab>
							</van-tabs>
						</div>
					</div>
				</section>
			</div>
			<!-- 二级导航end -->
			<!-- 内容开始 -->
			<div class="swiper-slide" :class="categoryList.length<=0?'pt46':''">
				<div class="IndCon Huans">
					<!--banner-开始-->
					<div class="swiper banner">
						<!-- height="180" -->
						<van-swipe class="my-swipe" @change="BannerChange" :autoplay="3000"
							indicator-color="var(--themetext-color)">
							<van-swipe-item v-for="(item, index) in banners" :key="index" @click="BannerClick(index)">
								<!-- <img class="my-swipe-img" :src="item.thumb"> -->
								<van-image class="my-swipe-img" fit="contain" :src="item.thumb" />
							</van-swipe-item>
						</van-swipe>
					</div>
					<!--banner-结束-->

					<!--通知-开始-->
					<div class="sollK Huans flexC fl-bet">
						<!-- <div class="sollC flexC"><span class="wapiconfont icon-gonggao"></span>
							<p>{{$t('message.gonggao')}}</p>
						</div> -->
						<div class="swiper sollN">
							<van-notice-bar left-icon="volume-o" :scrollable="false" color="var(--themetext-color)"
								background="var(--qbg-color)">
								<van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
									<van-swipe-item v-for="(item, index) in announces" :key="index"
										@click="showDiag(item.desc)" class="van-ellipsis">
										{{ item.title }}
									</van-swipe-item>
								</van-swipe>
							</van-notice-bar>
						</div>
					</div>
					<!--通知-结束-->
				</div>
				<!-- 推荐 -->
				<div v-show="Tabactive==0" class="Tabcont">
					<!-- 标题栏 每日视频推荐-->
					<div class="Tabline">
						<div class="TablineFL">
							<img class="Tablineimg" src="@/assets/wap/images/icon/jinpai.png">
							<div class="Tablinetxt">{{$t('message.Dailyvideo')}}</div>
						</div>
						<router-link :to="{name: 'moreList',query:{tjIdx:1,type:Tabactive}}">
							<div class="TablineFR">
								<span class="Tablinemore">{{$t('message.SeeMore')}}</span>
								<span class="wapiconfont icon-xiangyoujiantou"></span>

							</div>
						</router-link>
					</div>
					<!-- 标题栏end -->
					<!-- 列表开始 -->
					<div class="IndGme Huans">
						<div class="IndGmeK flex fl-bet">
							<div class="IndGmea" v-for="(item1, index1) in DailyList" :key="index1"
								@click="godetail(item1)">
								<div class="IndGmeaCont">
									<!-- <img src="@/assets/wap/images/znot/fb.png"> -->
									<img :src="item1.thumb">
									<div class="LTtag">{{item1.level_text}}</div>
									<!-- <div class="IndGmeP">
									<p>{{item1.platformShortName}}</p>
								</div> -->
									<div class="SCbox" @click.stop="setCollect(item1,index1,1)">
										<van-icon v-if="item1.is_collect==0" name="add" color="#CFCDCB" />
										<van-icon v-else name="like" color="#D81E06" />
									</div>
									<div class="RbTimebox">{{item1.thumb_time}}
									</div>
								</div>

								<div class="IndGmeTitle van-ellipsis">{{item1.title}}
								</div>

							</div>
						</div>
					</div>
					<!-- 列表end -->
					<div v-if="DailyList.length>0" @click="Changebatch(1)" class="Lkbutton">
						{{$t('message.Changebatch')}}
					</div>
					<!-- 标题栏 -->
					<!-- <div class="Tabline">
						<div class="TablineFL">
							<img class="Tablineimg" src="@/assets/wap/images/icon/jinpai.png">
							<div class="Tablinetxt">游戏推荐</div>
						</div>
						<router-link :to="{name: 'moreList'}">
							<div class="TablineFR">
								<span class="Tablinemore">{{$t('message.SeeMore')}}</span>
								<span class="wapiconfont icon-xiangyoujiantou"></span>
			
							</div>
						</router-link>
					</div> -->
					<!-- 标题栏end -->
					<!-- 滑动列表 -->
					<!-- <div class="scrollList">
						<div class="IndGmelist"> -->

					<!-- <van-swipe :loop="false" :width="300">
						  <van-swipe-item> -->
					<!-- 	<div class="IndGmeitem" v-for="(item2, index2) in item.platforms"
								:key="index2" @click="godetail(item2)">
								<img src="@/assets/wap/images/znot/fb.png">
								<img :src="item2.url">
								<div class="LTtag">{{$t('message.Recommend')}}</div> -->

					<!-- 	<div class="SCbox" @click.stop="setCollect(item2,index2,2)">
									<van-icon v-if="item2.is_collect==0" name="add" color="#CFCDCB" />
									<van-icon v-else name="like" color="#D81E06" />
								</div>
								<div v-if="index2==0||index2==1" class="RbTimebox">2:18:31</div>
							</div> -->
					<!-- </van-swipe-item>
						</van-swipe> -->
					<!-- 	</div>
					</div> -->
					<!-- 滑动列表end -->
					<!-- 标题栏精选推荐 -->
					<div class="Tabline">
						<div class="TablineFL">
							<img class="Tablineimg" src="@/assets/wap/images/icon/jinpai.png">
							<div class="Tablinetxt">{{$t('message.Choicevideo')}}</div>
						</div>
						<router-link :to="{name: 'moreList',query:{tjIdx:2,type:Tabactive}}">
							<div class="TablineFR">
								<span class="Tablinemore">{{$t('message.SeeMore')}}</span>
								<span class="wapiconfont icon-xiangyoujiantou"></span>

							</div>
						</router-link>
					</div>
					<!-- 标题栏end -->
					<!-- 精选推荐列表开始 -->
					<div v-if="ChoiceList.length>0" class="IndGme Huans">
						<van-list v-model="loading2" :finished="finished2" :finished-text="$t('message.nomore')"
							@load="getVideoIndex1">
							<div class="IndGmeK flex fl-bet">
								<div class="IndGmea" v-for="(item2, index2) in ChoiceList" :key="index2"
									@click="godetail(item2)">
									<div class="IndGmeaCont">
										<!-- <img src="@/assets/wap/images/znot/fb.png"> -->
										<img :src="item2.thumb">
										<div class="LTtag">{{item2.level_text}}</div>
										<!-- <div class="IndGmeP">
									<p>{{item2.platformShortName}}</p>
								</div> -->
										<div class="SCbox" @click.stop="setCollect(item2,index2,2)">
											<van-icon v-if="item2.is_collect==0" name="add" color="#CFCDCB" />
											<van-icon v-else name="like" color="#D81E06" />
										</div>
										<div class="RbTimebox">{{item2.thumb_time}}
										</div>
									</div>

									<div class="IndGmeTitle van-ellipsis">{{item2.title}}
									</div>

								</div>
							</div>
						</van-list>
					</div>
					<!-- 精选推荐列表end -->
					<!-- <div v-if="ChoiceList.length>0" @click="Changebatch(2)" class="Lkbutton">
						{{$t('message.Changebatch')}}
					</div> -->
				</div>
				<!-- 推荐end -->
				<!-- 最新 -->
				<div v-show="Tabactive==1||Tabactive==2||Tabactive==3" class="Tabcont">
					<!-- 标题栏 -->
					<div class="Tabline">
						<div class="TablineFL">
							<img class="Tablineimg" src="@/assets/wap/images/icon/jinpai.png" />
							<!-- 每日最新更新 -->
							<div v-show="Tabactive==1" class="Tablinetxt">
								{{$t('message.videoList1')}}
							</div>
							<!-- 人气最佳视频 -->
							<div v-show="Tabactive==2" class="Tablinetxt">
								{{$t('message.videoList2')}}
							</div>
							<!-- 短视频 -->
							<div v-show="Tabactive==3" class="Tablinetxt">
								{{$t('message.videoList3')}}
							</div>
						</div>
						<router-link :to="{name: 'moreList',query:{tjIdx:0,type:Tabactive}}">
							<div class="TablineFR">
								<span class="Tablinemore">{{$t('message.SeeMore')}}</span>
								<span class="wapiconfont icon-xiangyoujiantou"></span>

							</div>
						</router-link>
					</div>
					<!-- 标题栏end -->
					<!-- 列表开始 -->
					<!-- v-show="Tabactive==1" -->
					<!-- v-if="Videolists.length>0" -->
					<div v-if="Videolists.length>0" class="IndGme Huans">
						<van-list v-model="loading3" :finished="finished3" :finished-text="$t('message.nomore')"
							@load="getVideolists">
							<div class="IndGmeK flex fl-bet">
								<div class="IndGmea" v-for="(item3, index3) in Videolists" :key="index3"
									@click="godetail(item3)">
									<div class="IndGmeaCont">
										<!-- <img src="@/assets/wap/images/znot/fb.png"> -->
										<img :src="item3.thumb">
										<div class="LTtag">{{item3.level_text}}</div>
										<!-- <div class="IndGmeP">
									<p>{{item3.platformShortName}}</p>
								</div> -->
										<div class="SCbox" @click.stop="setCollect(item3,index3,3)">
											<van-icon v-if="item3.is_collect==0" name="add" color="#CFCDCB" />
											<van-icon v-else name="like" color="#D81E06" />
										</div>
										<div class="RbTimebox">
											{{item3.thumb_time}}
										</div>
									</div>

									<div class="IndGmeTitle van-ellipsis">{{item3.title}}
									</div>

								</div>
							</div>
						</van-list>
					</div>
					<!-- 列表end -->
					<div v-else class="nodata">
						<img class="no_img" src="@/assets/wap/images/icon/nodata.png" />
						<p class="no_text">{{$t('message.nodata')}}~</p>
					</div>
				</div>
				<!-- 最新end -->
			</div>
			<!-- 内容end -->
		</div>
		<!-- 头部导航end -->

		<tabbar></tabbar>
	</div>
</template>

<script>
	// import Header from '@/components/wap/public/header.vue';
	import tabbar from '@/components/wap/public/tabbar.vue';
	import {
		Dialog
	} from 'vant';
	import {
		queryIndexBanners,
		queryConfig,
		getLangs,
		queryNotices,
		queryVideocategory,
		queryVideoIndex,
		queryVideolists,
		collectVideo,
		cancleVideo,
		getUserInfo

	} from "@/api/urls";

	export default {
		components: {
			// Header,
			tabbar
		},
		name: 'index',
		inject: [
			'reload'
		],
		data() {
			return {
				TabList: [{
						id: 1,
						title: this.$t('message.Recommend'), // "推荐",
					}, {
						id: 2,
						title: this.$t('message.zuixin'), //"最新",
					}, {
						id: 3,
						title: this.$t('message.hot'), //"热门",
					}, {
						id: 4,
						title: this.$t('message.free'), //"短视频"改成免费,
					},
					// {
					// 	id: 5,
					// 	title:this.$t('message.game'),//"游戏",
					// },
				],
				Tabactive: 0,
				showPopover: false, //语言弹窗
				actions: [],
				flag: false,
				Curlang: {
					label: '',
					img: "",
					value: '',
				},
				categoryList: [], //分类列表
				cateid: 0,
				active: 0,
				announces: [], //公告列表
				banners: [], //轮播图
				DailyList: [], //每日推荐列表
				ChoiceList: [], //精选推荐列表
				Videolists: [], //1最新，2热门，3短视频列表
				page1: 1,
				page2: 1,
				page3: 1,
				loading2: false,
				finished2: false,
				loading3: false,
				finished3: false,
				Config: {}, //系统配置
			}
		},
		created() {
			this.getLanguages();
			this.getBanners()
			this.getAnnounce()
			this.getVideocategory()
			this.DailyList = [];
			this.page1 = 1;
			this.getVideoIndex()
			this.ChoiceList = [];
			this.page2 = 1;
			this.getVideoIndex1()
			// this.getVideolists();
			this.getSystem() //获取系统变量
			this.getUserInfo();
		},
		methods: {
			onTabClick(name, title) {
				this.Tabactive = name;
				console.log(name, title);
				if (this.Tabactive == 0) {
					this.DailyList = [];
					this.page1 = 1;
					this.getVideoIndex()
					this.ChoiceList = [];
					this.page2 = 1;
					this.getVideoIndex1()
				} else {
					this.Videolists = [];
					this.page3 = 1;
					this.getVideolists();
				}
			},
			// 切换二级分类
			cateChange(index) {
				this.active = index;
				this.cateid = this.categoryList[index].id;
				console.log(index, this.cateid, "cateChange");
				if (this.Tabactive == 0) {
					this.DailyList = [];
					this.page1 = 1;
					this.getVideoIndex()
					this.ChoiceList = [];
					this.page2 = 1;
					this.getVideoIndex1()
				} else {
					this.Videolists = [];
					this.page3 = 1;
					this.getVideolists();
				}
			},
			// 轮播图切换
			BannerChange(index) {
				this.current = index;
			},
			BannerClick(index) {
				this.current = index;
				var url = this.banners[index].url;
				if (url != '') {
					var temp = url.split('?'); //对url地址进行分割
					var pram1 = temp[0];
					var pram2 = temp[1];
					var pathurl = pram1.split('/'); //对url地址进行分割
					var path0 = pathurl[0];
					var path1 = pathurl[1];
					if (pram2 != undefined) {
						var keyValue = pram2.split("&");
						var objData = {};
						for (var i = 0; i < keyValue.length; i++) { //循环分割挂过后的地址
							var item = keyValue[i].split("=");
							var key = item[0];
							var value = item[1];
							objData[key] = value;
						}
					}
					// console.log(url,"url");
					// console.log(pram1,"pram1",pram2,"pram2");
					// console.log(pathurl,"pathurl", path0,"path0",path1,"path1");
					// console.log(keyValue,"keyValue",objData,'objData') //objData就是我么分割后从上个页面传过来数据的对象
					if (path0 == '' && pram2 != undefined) {
						// 页面链接
						this.$router.push({
							path: pram1,
							query: objData
						})

					} else {
						this.$router.push({
							path: '/link',
							query: {
								url: url
							}
						})
					}
				}
				console.log(url, "BannerClick")
			},
			//显示国际化
			showLang() {
				this.flag = !this.flag;
			},
			//选择国际化
			onSelect(item, index) {
				console.log(item);
				console.log(index);
				this.flag = !this.flag;
				if (item.value == 'CN') {
					this.$i18n.locale = 'zh';
					this.$store.commit('setIlang', 'zh')
				} else if (item.value == 'TW') {
					this.$i18n.locale = 'tw';
					this.$store.commit('setIlang', 'tw')
				} else if (item.value == 'EN') {
					this.$i18n.locale = 'en';
					this.$store.commit('setIlang', 'en')
				} else if (item.value == 'VN') {
					// 越南语跳转到越南网站
					this.$i18n.locale = 'vn';
					this.$store.commit('setIlang', 'vn')
					// this.$router.push({
					// 				path: '/web',
					// 				query: {
					// 					url: data.url
					// 				}
					// 			})
					// 			// window.location.href = data.url;
					// this.showPopover = false;
					// return false
				}else if (item.value == 'KO') {
					this.$i18n.locale = 'ko';
					this.$store.commit('setIlang', 'ko')
				}else if (item.value == 'TH') {
					this.$i18n.locale = 'th';
					this.$store.commit('setIlang', 'th')
				}else {
					this.$toast('您所在地区不支持！');
					this.showPopover = false;
					return false
				}
				this.Curlang = item;
				this.$store.commit('setLang', item.value)
				this.showPopover = false;
				this.getVideocategory()
				// this.$router.go(0);
				this.reload() //刷新页面
			},
			//获取语言列表
			getLanguages() {
				var params = {
					'lang': this.$store.state.lang,
				}
				getLangs(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// console.log(data, "data")
						this.actions = data;
						this.Curlang = data[0];
						// 获取语言
						var langval = this.$store.state.lang;
						for (var i in this.actions) {
							if (this.actions[i].value == langval) {
								this.Curlang = this.actions[i];
								console.log(this.Curlang, "获取语言key")
							}
						}
						//默认进入的兼容处理
						if (this.Curlang.value == '') {
							this.Curlang = this.actions[0];
							console.log(this.Curlang, "获取默认语言key")
							this.$i18n.locale = 'zh';
							this.$store.commit('setIlang', 'zh')
							this.$store.commit('setLang', 'CN')
							this.getVideocategory()
						}
					}
				})
			},
			showDiag(content) {
				Dialog.alert({
					title: this.$t('message.gonggao'),
					confirmButtonText: this.$t('message.close'),
					confirmButtonColor:'var(--anbut-bgcolor)',
					theme: 'round-button',
					message: content + '',
				}).then(() => {
					// on close
				});
			},
			//跳转地址
			navigate(path) {
				//判断是否登录
				if (this.$store.state.token == '') {
					this.$toast(this.$t('message.plogin'));
					return false;
				}
				this.$router.push({
					path: path
				});
			},
			//公告列表
			getAnnounce() {
				var params = {
					'type': '首页公告',
					'lang': this.$store.state.lang,
				};
				queryNotices(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.announces = data;
					}
				})
			},
			//轮播图列表
			getBanners() {
				var params = {
					'type': '首页',
					'lang': this.$store.state.lang,
					'form': 1, //1wap端 2pc端
				};
				queryIndexBanners(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.banners = data;
					}
				})
			},
			//视频分类
			getVideocategory() {
				// this.$toast(this.$store.state.lang);
				var params = {
					'lang': this.$store.state.lang,
					// 'lang': 'CHS',//CN
				};
				queryVideocategory(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.categoryList = data;
						if (data.length > 0) {
							this.cateid = data[0].id;
						}
					}
				})
			},
			//首页推荐/精选视频列表
			getVideoIndex() {
				var params = {
					'type': 1, //1每日推荐，2精选
					'cate_id': this.cateid,
					'page': this.page1,
					'limit': 4,
						'lang': this.$store.state.lang,
				};
				queryVideoIndex(params).then(({
					code,
					data,
					pages
				}) => {
					if (code === 200) {
						if (this.page1 <= pages) {
							this.DailyList = data;
						} else {
							// this.$toast(this.$t('message.nomore'));
						}
					}
				})
			},
			//首页推荐/精选视频列表
			getVideoIndex1() {
				this.loading2 = true;
				this.finished2 = false;
				var params = {
					'type': 2, //1每日推荐，2精选
					'cate_id': this.cateid,
					'page': this.page2,
					'limit': 8,
						'lang': this.$store.state.lang,
				};
				queryVideoIndex(params).then(({
					code,
					data,
					pages
				}) => {
					if (code === 200) {
						// if (this.page2 <= pages) {
						// 	this.ChoiceList = data;
						// } else {
						// 	// this.$toast(this.$t('message.nomore'));
						// }
						const _list = data;
						this.ChoiceList = [...this.ChoiceList, ..._list];

						if (this.page2 < pages) {
							this.page2 = this.page2 + 1;
							// 加载状态结束
							this.loading2 = false;
						} else {
							this.finished2 = true;
						}
					} else {
						this.finished2 = true;
						this.$toast(msg);
					}
				})
			},
			// 顶部推荐、最新、短视频列表
			getVideolists() {
				this.loading3 = true;
				this.finished3 = false;
				var params = {
					'type': this.Tabactive, //1最新，2热门，3短视频
					'cate_id': this.cateid,
					'page': this.page3,
					'limit': 10,
					'lang': this.$store.state.lang,
				};
				queryVideolists(params).then(({
					code,
					data,
					pages,
					msg
				}) => {
					// if (code === 200) {
					// 	this.Videolists = data;
					// 	console.log(this.Videolists, "this.Videolists")
					// 	// data.map((item, index) => {
					// 	// 	if (item['name'] == this.$store.state.lang) {
					// 	// 		this.games = item['map'];
					// 	// 	}
					// 	// })
					// }
					if (code === 200) {
						const _list = data;
						this.Videolists = [...this.Videolists, ..._list];

						if (this.page3 < pages) {
							this.page3 = this.page3 + 1;
							// 加载状态结束
							this.loading3 = false;
						} else {
							this.finished3 = true;
						}
					} else {
						this.finished3 = true;
						this.$toast(msg);
					}
				})
			},
			// 换一批
			Changebatch(idx) {
				if (idx == 1) {
					this.page1 = this.page1 + 1;
					this.getVideoIndex()
				}
				// if (idx == 2) {
				// 	this.page2 = this.page2 + 1;
				// 	this.getVideoIndex1()
				// }
			},
			//进入详情
			godetail(item) {
				console.log(item, "item")
				if (item.level_text == "VIP") {
					if (this.$store.state.token == '') {
						this.$toast(this.$t('message.plogin'));
						return false;
					}
					if (this.$store.state.userInfo.is_vip == 0) {
						this.$toast("请升级为SVIP后观看");
						return false;
					}
					this.$router.push({
						name: 'play',
						query: {
							id: item.id,
						}
					});
				}
				if (item.level_text == "免费") {
					this.$router.push({
						name: 'play',
						query: {
							id: item.id,
						}
					});
				}

			},
			// 收藏
			setCollect(item, index, pidx) {
				//判断是否登录
				if (this.$store.state.token == '') {
					this.$toast(this.$t('message.plogin'));
					return false;
				}
				var that = this;
				// 这个is_collect 值   1 是已经收藏  0是没有收藏
				if (item.is_collect == 1) {
					that.delcollect(item.id, index, pidx) //删除收藏
				} else {
					that.addcollect(item.id, index, pidx) //添加收藏
				}
			},
			// 添加收藏
			addcollect(id, sindex, pidx) {
				var params = {
					'id': id,
				};
				collectVideo(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						if (pidx == 1) {
							this.DailyList[sindex].is_collect = 1;
						} else if (pidx == 2) {
							this.ChoiceList[sindex].is_collect = 1;
						} else if (pidx == 3) {
							this.Videolists[sindex].is_collect = 1;
						}
						this.$toast(msg);
					} else {
						this.$toast(msg);
					}
				})
			},
			//删除收藏
			delcollect(id, sindex, pidx) {
				var params = {
					'id': id,
				};
				console.log(params)
				cancleVideo(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						if (pidx == 1) {
							this.DailyList[sindex].is_collect = 0;
						} else if (pidx == 2) {
							this.ChoiceList[sindex].is_collect = 0;
						} else if (pidx == 3) {
							this.Videolists[sindex].is_collect = 0;
						}
						this.$toast(msg);
					} else {
						this.$toast(msg);
					}
				})
			},
			getUserInfo() {
				// console.log(this.$store.state.userInfo,"userInfo")
				//判断是否登录
				if (this.$store.state.token == '') {
					return false;
				} else {
					var params = {
						// "token":this.$store.state.token,
						'lang': this.$store.state.lang,
					}
					getUserInfo(params).then(({
						code,
						data
					}) => {
						if (code === 200) {
							console.log(code, "code1")
							this.$store.commit('setUserInfo', data)
							this.userInfo = data;
							this.balance = data.money;
							this.isagent = data.is_agent; //1是代理，0普通用户

						} else {
							console.log(code, "code2")
							this.$store.commit('setLoginOut');
						}
					})
				}
			},
			//获取系统变量
			getSystem() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryConfig(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.Config = data;
						console.log("系统变量", data)
						this.$store.commit('setConfig', data)
						// site_closevideo=1是关闭视频。0开启。
						if (data.site_closevideo == 1) {
							this.isHideVideo = true;
							this.$store.commit('setHideVideo', true)
						} else {
							this.isHideVideo = false;
							this.$store.commit('setHideVideo', false)
						}
					}
				})
			},

		}
	}
</script>
<style lang="less" scoped>
	.pageCont {
		background-color: var(--bg-color);
	}

	.indexbox {
		padding-bottom: 50px;
	}

	.indexbox /deep/ .van-tab {
		font-size: 0.12rem;
		padding: 0 0px;
	}

	.indexbox /deep/.van-tab--active {
		font-size: 0.12rem;
	}

	.heardbox {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		margin: 0 auto;
		z-index: 40;
		// width: 100%;
		height: 46px;
		padding: 0 0.06rem;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: var(--bg-color);
	}

	.heard_fl {
		// flex: 1;
		width: 55%;
	}

	.heard_fr {
		// position: absolute;
		// top: 10px;
		// right: 10px;
		width: 45%;
		height: 44px;
		margin-left: 5px;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		.van-icon {
			margin: 0 4px;
		}
	}

	.IndTit {
		padding: 0 0.06rem;
	}

	// 国际化
	.hdcn {
		margin-left: 4px;
		position: static;
		// position: relative;
		left: auto;
		justify-content: flex-start;
		flex-wrap: nowrap;
	}

	.tipslang {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 10px 20px;
		border-bottom: 1px solid var(--border-color);
	}

	.tipslang img {
		width: 30px;
		height: 20px;
	}

	.langimg {
		width: 20px;
		// height:10px;
		border-radius: 2px;
	}

	.langtxt {
		color: var(--font-color);
		font-size: 0.09rem;
	}

	.tipslang span {
		margin-left: 10px;
		font-size: 14px;
		color: #999;
	}

	.heardtwobox {
		padding: 46px 0 0;
	}

	.IndCon {
		padding: 0.06rem 0 0;
	}

	.my-swipe {
		border-radius: 5px;
	}

	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		// line-height: 150px;
		text-align: center;
		// background-color: #39a9ed;
		background-color: var(--bg-color);
	}

	.banner .my-swipe .my-swipe-img {
		width: 100%;
		height: 100%;
		display: block;
		border-radius: 5px;
		overflow: hidden;
	}

	.van-swipe__indicators>.van-swipe__indicator {
		background-color: #fff;
		opacity: 0.8;
	}

	.sollK {
		padding: 0.1rem 0;
	}

	.notice-swipe {
		height: 0.2rem;
		line-height: 0.2rem;
		font-size: 12px;
		border-radius: 2px;
	}

	.sollN .van-notice-bar {
		height: 0.2rem;
		line-height: 0.2rem;
		padding: 0;
	}

	.swiper-slide {
		padding: 0 0.06rem;
		flex-shrink: 0;
		width: 100%;
		height: 100%;
		position: relative;
		transition-property: transform;
		box-sizing: border-box;
	}

	.swiper-wrapper /deep/.van-tabs--line .van-tabs__wrap {
		height: 44px;
	}

	.swiper-wrapper .IndTita {
		height: auto;
		padding: 4px 15px;
		border-radius: 100px;
		border: 0px solid #d9e3ee;
	}

	.swiper-wrapper /deep/.van-tabs__nav--line.van-tabs__nav--complete {
		padding: 0;
	}

	.swiper-wrapper /deep/.van-tabs__wrap--scrollable .van-tab {
		padding-right: 10px;
		padding-left: 0;
	}

	.swiper-wrapper /deep/.van-tabs__line {
		display: none;
	}

	.van-swipe-item {
		text-align: left;
	}

	.van-dialog--round-button .van-dialog__message {
		text-align: left;
	}

	#thumbs2 .swiper-slide-thumb-active>div {
		background: var(--tabson-bgcolor);
		border: 1px solid var(--tabson-bdcolor);
		color: var(--tabson-color);
	}

	.IndGme {
		padding: 0.1rem 0;
	}

	.IndGmeK {
		padding-bottom: 0;

		.IndGmea {
			position: relative;
			width: 49%;

			.IndGmeaCont {
				position: relative;
				width: 100%;
				min-height: 115px;
			}

			.IndGmeTitle {
				color: var(--font-color);
				margin: 6px 0 10px;
				font-size: 0.12rem;
				text-align: left;
			}
		}
	}



	.scrollList {
		padding: 0.1rem 0;
		width: 100%;
		box-sizing: border-box;
		overflow: hidden;

		.IndGmelist {
			width: 100%;
			text-align: left;
			overflow-x: auto;
			white-space: nowrap;
		}

		.IndGmeitem {
			display: inline-block;
			position: relative;
			width: 150px;
			margin-right: 0.06rem;

			img {
				width: 100%;
				display: block;
			}
		}
	}

	.pt46 {
		padding-top: 46px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/wap/index.vue